import { useDispatch, useSelector } from "react-redux";
import TextField from "../../../../components/input-fields/TextField";
import { updateSyncDomain } from "../../../../redux/actions/CompanyDirectoryActions";

const NetsapiensAutoSyncSection = () => {
  const dispatch = useDispatch();
  const { updatedNetsapiensSyncDomain } = useSelector((state) => state.companyDirectory);

  const handleDomainChange = (value) => {
    dispatch(updateSyncDomain(value));
  };

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col gap-2">
        <TextField
          title="Domain"
          type="text"
          value={updatedNetsapiensSyncDomain}
          placeholder="type your domain here 'example.com'"
          onChange={handleDomainChange}
          errorMessage=""
          required={true}
        />
      </div>
    </div>
  );
};

export default NetsapiensAutoSyncSection;
